import { HostPlatform, Azure, JIRA, Monday } from '../../config/hostPlatform';
import * as azureUsers from './azureUsers';
import * as mondayUsers from './mondayUsers';
import * as jiraUsers from './jiraUsers';

const Platforms = new Map([
  [Monday, mondayUsers],
  [Azure, azureUsers],
  [JIRA, jiraUsers],
]);

const api = Platforms.get(HostPlatform.activeId);

const { getMyself, getUsers, getUsersById } = api;

export { getMyself, getUsers, getUsersById };
